import { Palette } from '@infoods/lifebase-ui';

const tooltipFont = {
  family: "'Lato', sans-serif",
  size: 11,
  weight: 600,
} as const;

export const getTooltipBaseOptions = (palette: Palette) => ({
  displayColors: false,
  backgroundColor: 'rgba(110, 110, 121, 0.84)',
  titleFont: tooltipFont,
  titleColor: palette.neutral[200],
  bodyFont: tooltipFont,
  bodyColor: palette.white,
  caretPadding: 6,
});
